import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from "@angular/router";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { CommonService } from "../../../common/common.service";
import { ProviderService } from "../provider.service";
import { NgxSpinnerService } from 'ngx-spinner';
import Swal from "sweetalert2";
import { OrganizationService } from '../../organization-management/organization.service';
// import Swal from "sweetalert2";
@Component({
  selector: 'app-edit-biller',
  templateUrl: './edit-biller.component.html',
  styleUrls: ['./edit-biller.component.css']
})
export class EditBillerComponent implements OnInit {

  providerForm1: FormGroup;
  formSubmitted: boolean = false;
  showDesciptionError: boolean = true;
  featureList = [];
  finalFeatureList = [];
  temp: any;
  emailPattern = /^[a-zA-Z0-9.!#$%&'*+\/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)+$/;
  codeId =""
  codeDetail:any;
  constructor(
    private router: Router,
    private fb: FormBuilder,
    private spinner: NgxSpinnerService,
    private commonService: CommonService,
    private PlanService: ProviderService,
    private OrganizationService:OrganizationService,
    private route: ActivatedRoute,
  ) { }

  ngOnInit() {
    this.codeId = this.route.snapshot.params["providerId"];
    this.initialiseForms();
    this.getcodeById();
  }
  getcodeById() {
    this.spinner.show();
    let query = "codeId=" + this.codeId;
    this.PlanService.getCodeApi(query).subscribe(res => {
      if ((res["status"] = "Success")) {
        this.codeDetail = res.data.codeList[0];
        this.updateForm();
        this.spinner.hide()
      } else {
        this.spinner.show()
        Swal.fire({
          type: "error",
          title: "Error",
          text: res.msg
        });
      }
    }, err => {
      this.spinner.hide();
    });

  }
  updateForm() {
    this.providerForm1.patchValue({
      description: this.codeDetail["description"],
      monthlyRedemptionCount: this.codeDetail["monthlyRedemptionCount"],
      code: this.codeDetail["code"],
    });
    this.providerForm1.controls.code.disable();
  }
  
  onlyNumberKey(event) {

    return (event.charCode == 8 || event.charCode == 0) ? null : event.charCode >= 48 && event.charCode <= 57;
  }
  initialiseForms() {
    this.providerForm1 = this.fb.group({
      monthlyRedemptionCount: ["", [Validators.required]],
      description: ["", [Validators.required]],
      code: ["", [Validators.required]]

    });
    
  }


  Addplan() {
    this.formSubmitted = true;
    if (this.providerForm1.valid) {
      let request = this.providerForm1.value;
      request['codeId'] = this.codeId;
      this.PlanService.editCode(request).subscribe(data => {
        if ((data["status"] = "Success")) {
          Swal.fire("Success", "Billing Code updated successfully!", "success");
          this.router.navigate(["/main/provider/billercode"]);
        } else {
          Swal.fire({
            type: "error",
            title: "Error",
            text: data.msg
          });
        }
      });
    }




  }


  cancel() {
    this.router.navigate(["/main/provider/billercode"]);
  }
}



